export function toHyphenCase(property: string): string {
  if (!property) {
    return '';
  }
  return property.includes('-')
    ? property
    : property.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
}
